<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div #header1 class="container green containerMenu">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="assets/img/logo.jpg" height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://linkexperiences.com/" class="navbar-brand"
            target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="../assets/images/logos-header/le.svg" alt="logo" class="brand-logo" style="height: 75px;">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="width: inherit;">
            <ul class="navbar-nav menuContainer" style="width: inherit;">
                <li class="nav-item menuItem"><a href="https://linkexperiences.com/" target="_blank">Home</a></li>
                <li class="nav-item menuItem"><a href="https://linkexperiences.com/all-destinations/"
                        target="_blank">Destinations</a></li>
                <li class="nav-item menuItem"><a href="https://linkexperiences.com/packages/weddings/"
                        target="_blank">Experiences</a></li>
                <li class="nav-item menuItem"><a href="https://linkexperiences.com/blog/" target="_blank">Blog</a></li>
                <li class="nav-item menuItem menuItemLast"><a href="https://linkexperiences.com/#contact-us"
                        target="_blank">Contact Us</a>
                </li>
            </ul>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
        <div class="container green containerHeader"
            style="justify-content: center; align-items: center; flex-direction: row!important;"
            class="responsiveHeader">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding: 5px; color: white;">
                <i class="fa fa-bars fa-2x"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://linkexperiences.com/" target="_blank">Home</a></li>
        <li class="nav-item menuItem"><a href="https://linkexperiences.com/all-destinations/"
                target="_blank">Destinations</a></li>
        <li class="nav-item menuItem"><a href="https://linkexperiences.com/packages/weddings/"
                target="_blank">Experiences</a></li>
        <li class="nav-item menuItem"><a href="https://linkexperiences.com/blog/" target="_blank">Blog</a></li>
        <li class="nav-item menuItem menuItemLast"><a href="https://linkexperiences.com/#contact-us"
                target="_blank">Contact Us</a>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>